export default {
	title: 'presence_fine_tuning',
	component: 'presence_fine_tuning',
};
